import { Metamodel } from '../base/model';
import { IModel, IAttribute, IViolation, IValidationContext } from '../base/annotation';
import { LinkedService } from './linkedservice';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { GlobalVariables } from '../../constants/globals';
import {validateLinkedServiceProperties} from '../../shared/utils/linkedservice-validation-util';
import { format, sanitizeAndFormatString } from '../../shared/utils/string.util';
import { RootFolderType } from './lakehouse.linkedservice';


@Metamodel.model({
    name: ModelConstants.mountedRelationalDatabaseLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.MountedRelationalDatabase_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.MountedRelationalDatabase_DisplayText)
    ],
    validator: MountedRelationalDatabaseLinkedService.validateMountedRelationalDatabase
})
export class MountedRelationalDatabaseLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly WORKSPACE_ID: IAttribute;
    public static readonly ARTIFACT_ID: IAttribute;
    public static readonly ROOT_FOLDER: IAttribute;

    public static async validateMountedRelationalDatabase(
        linkedService: MountedRelationalDatabaseLinkedService,
        context: IValidationContext
    ): Promise<IViolation[]> {
        if (GlobalVariables.isTrident) {
            return validateLinkedServiceProperties(linkedService, [
                MountedRelationalDatabaseLinkedService.ARTIFACT_ID,
                MountedRelationalDatabaseLinkedService.WORKSPACE_ID
            ]);
        }
        return undefined;
    }

    public override readonly tridentArtifactType = ModelConstants.mountedRelationalDatabaseArtifactType;

    @Metamodel.attribute({
        display: shellStringResources.WorkspaceId,
        association: 'WORKSPACE_ID',
        accepts: ['String'],
        templatable: true
    })
    public workspaceId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ArtifactId,
        association: 'ARTIFACT_ID',
        accepts: ['String'],
        templatable: true
    })
    public artifactId?: string;

    @Metamodel.attribute({
        display: shellStringResources.RootFolder,
        association: 'ROOT_FOLDER',
        templatable: true,
        constraint: {
            validator: (linkedservice: MountedRelationalDatabaseLinkedService): IViolation[] | undefined => {
                if (!['Files', 'Tables'].includes(linkedservice?.rootFolder)) {
                    return [
                        {
                            message: () =>
                                sanitizeAndFormatString(
                                    shellStringResources.RootFolder_InvalidValue,
                                    linkedservice.rootFolder
                                )
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public rootFolder?: RootFolderType = 'Tables';

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
